import { AllFacets, Creative } from '@kaizenplatform/creative-search-entity';

export interface ICreative {
  count: number;
  creatives: Creative[];
  facets: AllFacets;
}

/**
 * Director Web用のCreative Index
 *
 * @note creative search とちがってresultFacetsは不要なのでentityを別途定義
 */
class CreativeIndexForDirectorWeb {
  public readonly count: number;
  public readonly creatives: Creative[];
  /** 検索用に並び替えがされているためResultFacetと別で用意されている */
  public readonly facets: AllFacets;

  private constructor({ count, creatives, facets }: ICreative) {
    this.count = count;
    this.creatives = creatives;
    this.facets = facets;
  }

  public static fromJSON = (json: ICreative) => {
    const { count, creatives, facets } = Object.assign({}, json);

    if (typeof count !== 'number') {
      throw new Error('.count must be a number');
    }

    return new CreativeIndexForDirectorWeb({
      count,
      creatives,
      facets,
    });
  };
}

export default CreativeIndexForDirectorWeb;
